import { useEffect, useState } from "react";
import api from "../api/api";
import Loader from "../shared/loader";
import Pagination from "../shared/pagination";
import arrayUtilities from "../../utilities/arrayUtilities";
import Enums from "../../utilities/enum";
import { daysAgo, toDateTimeString } from "../../utilities/dateUtilities";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import stringHelpers from "../../utilities/stringHelpers";
import { getAppealRagStatus } from "../../utilities/appealRagStatus";
export const EnforcementSiteDetails = (props) => {
    const [renderedItems, setRenderedItems] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [pageNumber, setPageNumber] = useState(0);
    const fetchBreaches = (page) => {
        setIsLoading(true);

        api.getBreaches(
            (data) => { 
                setRenderedItems(data); 
                props.setCanRedo(false)
                props.setIsSelectAllChecked(false)
				props.setMultiSelectList([])
                setIsLoading(false) 
            },
            () => setIsLoading(false),
            props.searchQuery,
            !stringHelpers.isNullOrEmpty(props.selectedSiteId) ? [props.selectedSiteId] : null,
            null,
            props.isAssigned ?? null,
            props.filterStart,
            props.filterEnd,
            !stringHelpers.isNullOrEmpty(props.type) ? Number(props.type) : null,
            !arrayUtilities.isNullOrEmpty(props.statuses) ? props.statuses.map(item => Number(item)) : null,
            props.isOnHold,
            page,
            0,
            !stringHelpers.isNullOrEmpty(props.contraventionId) ? props.contraventionId : null,
            props.excludeVoided ? [503] : null,
            !arrayUtilities.isNullOrEmpty(props.previousStatuses) ? props.previousStatuses.map(item => Number(item)) : null,
            null, null,
            props.tagIds ?? null,
            props.organisationId,
            props.token
        );
    };

    useEffect(() => window.scrollTo({ top: 0 }), []);

    useEffect(() => {
        fetchBreaches(0);
        setPageNumber(0);
    }, [props.filterStart, props.searchQuery, props.filterEnd, props.type, props.statuses, props.previousStatuses, props.selectedSiteId, props.isOnHold, props.isAssigned, props.tagIds]);

    useEffect(() => {
        fetchBreaches(pageNumber)
    }, [props.siteSummaries])

    const handleCheckChange = (e, breach) => {
        if (e.target.checked) {
            props.setMultiSelectList(prevState => [...prevState, breach.id])
            if (renderedItems.items.length - props.multiSelectList.length === 1) {
                props.setIsSelectAllChecked(true)
            }
        } else if (!e.target.checked) {
            const index = props.multiSelectList.findIndex(item => item === breach.id)
            props.setMultiSelectList(prevState => prevState.toSpliced(index, 1))

            if (props.isSelectAllChecked) {
                props.setIsSelectAllChecked(false)
            }
        }
    }

    const handleSelectAll = (e) => {
        props.setIsSelectAllChecked(!props.isSelectAllChecked)
        if (e.target.checked) {
            props.setMultiSelectList(renderedItems.items.map(item => item.id))
        } else if (!e.target.checked) {
            props.setMultiSelectList([])
        }
    }

    useEffect(() => {
        props.setCanRedo(!arrayUtilities.isNullOrEmpty(props.multiSelectList) && renderedItems && renderedItems.items && renderedItems.items.filter(item => props.multiSelectList.includes(item.id)).every(breach => breach.breachStatus === 0 && !breach.isCurrentlyOnHold))
        if (props.setCanSendToDebtRecovery) {
            props.setCanSendToDebtRecovery(!arrayUtilities.isNullOrEmpty(props.multiSelectList) && renderedItems.items && renderedItems.items.filter(item => props.multiSelectList.includes(item.id)).every(breach => breach.breachStatus === 400))
        }
    }, [props.multiSelectList])

    return (
        <div className="card card-body p-0 bg-white" style={ { minHeight: "500px" } }>
            {
                (isLoading || props.isRedoing)
                    ? <div className="h-100"><Loader /></div>
                    : <>
                        <div className="card-body bg-white border-top details-container p-0 overflow-auto">
                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer ">
                                <thead className="bg-200 text-900">
                                    <tr>
                                        <td>
                                            <input
                                                onChange={e => handleSelectAll(e)}
                                                value={ props.isSelectAllChecked } checked={ props.isSelectAllChecked }
                                                type="checkbox"
                                            />
                                        </td>
                                        <td>Reference Number</td>
                                        <td>Reference VRM</td>
                                        <td>Site</td>
                                        <td>Contravention</td>
                                        <td>Contravention Date</td>
                                        <td>Status</td>
                                        {props.showAppealReceivedDateColumn && <td>Appeal / TOL Received</td>}
                                    </tr>
                                </thead>
                
                                <tbody>
                                    {
                                        renderedItems && !arrayUtilities.isNullOrEmpty(renderedItems.items) && 
                                        renderedItems.items.map(
                                            item => <tr>
                                                <td><input
                                                    onChange={e => handleCheckChange(e, item)}
                                                    value={item.id}
                                                    type="checkbox"
                                                    id={item.id}
                                                    checked={props.multiSelectList.includes(item.id)}
                                                    name={item.vrm}
                                                /></td>
                                                <td><Link to={`/organisation/${ props.organisationId }/breach/${ item.id }`}><h6 className="m-0">{item.referenceNumber}</h6></Link></td>
                                                <td><Link to={`/organisation/${ props.organisationId }/breach/${ item.id }`} className="number-plate-link"><h6 className="mb-0 small-number-plate">{item.vrm}</h6></Link></td>
                                                <td>
                                                    <Link to={`/organisation/${ props.organisationId }/client/${ props.selectedClientId }/site/${ props.selectedSiteId }`}><h6 className="m-0">{item.siteName}</h6></Link>
                                                </td>
                                                <td>{item.contraventionName}</td>
                                                <td>{toDateTimeString(item.timestamp)}</td>
                                                <td>{Enums.BreachStatus[item.breachStatus]}</td>
                                                {props.showAppealReceivedDateColumn && <td>
                                                    {item.appealOrTransferOfLiabilityReceivedDate && (() => {
                                                        const receivedDaysAgo = daysAgo(item.appealOrTransferOfLiabilityReceivedDate)
                                                        return <span className={`font-weight-semi-bold text-${getAppealRagStatus(receivedDaysAgo)}`}>
                                                            {toDateTimeString(item.appealOrTransferOfLiabilityReceivedDate)} - {receivedDaysAgo} {stringHelpers.pluralSuffixModifier(receivedDaysAgo, "day")} ago
                                                        </span>
                                                    })()}
                                                </td>}
                                            </tr>
                                        )
                                    }
                                </tbody>
                            </table>
                        </div>
                        <div className="d-flex justify-content-center row align-items-center pt-2">
                            <div className="col-auto align-items-center">
                                <Pagination
                                    totalResults={ renderedItems.totalCount }
                                    currentPage={ pageNumber }
                                    changePageNumber={ newPageNumber => { 
                                        fetchBreaches(newPageNumber); 
                                        setPageNumber(newPageNumber) 
                                    } } />
                            </div>
                        </div>
                    </>
            }
        </div>
    )
}